import { useEffect, useState } from 'react';
import useSdk from 'helpers/hooks/useSdk';

const useReviews = (productKey?: string) => {
  const [reviews, setReviews] = useState<any>(null); // TODO: type
  const sdk = useSdk();

  useEffect(() => {
    if (!productKey) {
      setReviews(null);
    }
    sdk
      .callAction<any>({
        // TODO: type
        actionName: 'feedaty/getReviews',
        payload: { sku: productKey },
      })
      .then(
        (res) => {
          setReviews(res.isError ? null : res.data.reviews.Data);
        },
        () => {
          setReviews(null);
        },
      );
  }, [productKey, sdk]);
  return {
    reviews,
  };
};

export default useReviews;
